/*!
 * Scripts
 * 템플릿 기본 및 퍼블리싱 스크립트 초기화.
 */

import {Globals, Variables} from './base/globals.js';
import Nav from './base/nav.js';

import DashboardPage from './pages/dashboardPage.js';
import ImageTag from './pages/imageTag.js';
import FormPage from './pages/formPage.js';

import Common from './common.js';

export default class Scripts {
  constructor() {
    this._initVariables();
    this._init();
  }

  // 모든 css 변수 설정 후 템플릿 노출
  _init() {
    setTimeout(() => {
      document.documentElement.setAttribute('data-show', 'true');
      document.body.classList.remove('spinner');
      this._initBase();
      this._initCommon();
      this._initPages();
    }, 100);
  }

  // 기본 스크립트 초기화
  _initBase() {
    if (typeof Nav !== 'undefined') {
      const nav = new Nav(document.getElementById('mainNav'));
    }
  }

  // 공통 플러그인 초기화
  _initCommon() {
    if (typeof Common !== 'undefined') {
      let common = new Common();
    }
  }

  // 페이지 특정 스크립트 초기화
  _initPages() {
    if (typeof DashboardPage != 'undefined') {
      const dashboardPage = new DashboardPage();
    }
    if (typeof ImageTag != 'undefined') {
      customElements.define('img-tag', ImageTag);
    }
    if (typeof FormPage !== 'undefined') {
      const formPage = new FormPage();
    }
  }

  // Globals.js 변수 초기화
  _initVariables() {
    if (typeof Variables !== 'undefined') {
      const variables = new Variables();
    }
  }
}
